/// <amd-module name="VC/Stats/ProjectLanguagesComponent" />
import * as React from "react";
import { format } from "VSS/Core/Util/String";
import { LegacyComponent } from "VSS/Legacy/Legacy";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { VssComponent, Components, IVssComponentContext, IVssComponentProperties } from "VSS/Platform/Layout";
import * as Resources from "VC/Stats/Resources";

interface ProjectLanguagesDataProviderData {
    projectLanguages: ProjectLanguagesState;
}

interface ProjectLanguagesState {
    languages: LanguageMetricInfo[];
}

interface LanguageMetricInfo {
    languagePercentage: number;
    name: string;
}

interface ProjectLanguagesComponentProps extends IVssComponentProperties {
    showHeader: boolean;
}

interface TagInfo {
    text: string;
    isFocusable: boolean;
    tooltipText?: string;
    tagItemAriaLabel?: string;
    deleteButtonAriaLabel?: string;
}

class ProjectLanguagesComponent extends VssComponent<ProjectLanguagesComponentProps, ProjectLanguagesState> {
    private static PROVIDER_ID = "ms.vss-code-web.vc-project-languages-data-provider";

    constructor(props: ProjectLanguagesComponentProps, context: IVssComponentContext) {
        super(props, context);
        this.state = { languages: [] };
    }

    public componentDidMount(): void {
        super.componentDidMount();
        this._loadLanguages();
    }

    public render(): JSX.Element | null {
        const languagesTags: TagInfo[] = (this.state.languages || []).map(languageMetrics => {
            return {
                text: languageMetrics.name,
                tooltipText: languageMetrics.languagePercentage.toString() + " %",
                tagItemAriaLabel: format(
                    Resources.ProjectLanguage_ItemNameAriaLabel,
                    languageMetrics.name,
                    languageMetrics.languagePercentage.toString()
                ),
                isFocusable: true
            };
        });

        if (languagesTags.length > 0) {
            return (
                <div className="project-languages">
                    {this.props.showHeader && (
                        <div className="title font-weight-semibold">{Resources.LanguagesHeaderText}</div>
                    )}
                    <LegacyComponent
                        wrappedType="TFS.ProjectOverview.TagListControl"
                        modules={[ "ProjectOverview/Scripts/Shared/Components/TagListControl" ]}
                        tags={languagesTags}
                        editMode={false}
                        listAriaLabel={Resources.ProjectLanguages_AriaLabel}
                    />
                </div>
            );
        }

        return null;
    }

    private _loadLanguages(): void {
        this.trackPromise(
            this.context.pageContext
                .getService<IVssContributionService>("IVssContributionService")
                .getDataAsync<ProjectLanguagesDataProviderData>(ProjectLanguagesComponent.PROVIDER_ID)
        ).promise.then((data: ProjectLanguagesDataProviderData | undefined) => {
            data && this.setState({ languages: data.projectLanguages.languages });
        }, () => {
            // no-op
        });
    }
}

Components.add("VC.ProjectLanguages", ProjectLanguagesComponent);
